// extracted by mini-css-extract-plugin
export default {"Subtitle":"SubTitle_Subtitle__EfxdW"};